// Pure JS document ready ...
document.addEventListener('DOMContentLoaded', (event) => {

    /*=============================================>>>>>
    = Accordeon =
    ===============================================>>>>>*/
    document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('accordion-toggle')) return;
        const content = document.querySelector(event.target.hash);
        if (!content) return;
        event.preventDefault();
        if (content.classList.contains('active')) {
            content.classList.remove('active');
            return;
        }
        const accordions = document.querySelectorAll('.accordion-content.active');
        for (let i = 0; i < accordions.length; i++) {
            accordions[i].classList.remove('active');
        }
        content.classList.toggle('active');
    });
    /*=============================================>>>>>
    = Close =
    ===============================================>>>>>*/
    const closeIt = document.querySelector('.close');
    if (closeIt) {
        closeIt.addEventListener('click', (e) => {
            document.querySelector('.popup').style.display = 'none';
        });
    };
    /*=============================================>>>>>
   = Video =
   ===============================================>>>>>*/
    const vid = document.querySelector('video');
    if (vid) {
        vid.play(0);
    };
    /*=============================================>>>>>
   = Toggler =
   ===============================================>>>>>*/
    const toggler = document.querySelector('.toggler');
    if (toggler) {
        toggler.addEventListener('click', (e) => {
            if(document.querySelector('.menu-principal-container')) {
                document.querySelector('.menu-principal-container ul').classList.toggle('d-block');
                document.querySelector('.menu-principal-container').classList.toggle('visible');
            }
            if(document.querySelector('.menu-menu-principal-en-container')) {
                document.querySelector('.menu-menu-principal-en-container ul').classList.toggle('d-block');
                document.querySelector('.menu-menu-principal-en-container').classList.toggle('visible');
            }

            if(document.querySelector('.menu-menu-principal-de-container')) {
                document.querySelector('.menu-menu-principal-de-container ul').classList.toggle('d-block');
                document.querySelector('.menu-menu-principal-de-container').classList.toggle('visible');
            }

            if(document.querySelector('.menu-menu-principal-it-container')) {
                document.querySelector('.menu-menu-principal-it-container ul').classList.toggle('d-block');
                document.querySelector('.menu-menu-principal-it-container').classList.toggle('visible');
            }

            if(document.querySelector('.menu-menu-principal-nl-container')) {
                document.querySelector('.menu-menu-principal-nl-container ul').classList.toggle('d-block');
                document.querySelector('.menu-menu-principal-nl-container').classList.toggle('visible');
            }

            if(document.querySelector('.menu-menu-principal-es-container')) {
                document.querySelector('.menu-menu-principal-es-container ul').classList.toggle('d-block');
                document.querySelector('.menu-menu-principal-es-container').classList.toggle('visible');
            }
        })
    };
    /*=============================================>>>>>
    = Fixed menu =
    ===============================================>>>>>*/
    function fixedMenu() {
        let navbar = document.querySelector("#header");
        if (window.pageYOffset >= 200) {
            navbar.classList.add("nav-scrolled");
        } else {
            navbar.classList.remove("nav-scrolled");
        }
    }
    document.addEventListener('scroll', () => {
        fixedMenu();
    });



    window.onscroll = function () {
        scrollFunction();
    };
});

//Bouton Revenir en haut
const backbutton = document.getElementById("backbut");
var windowHeight = window.innerHeight;
function scrollFunction() {
    if (
        document.body.scrollTop > windowHeight ||
        document.documentElement.scrollTop > windowHeight
    ) {
        backbutton.classList.add("visible");
    } else {
        backbutton.classList.remove("visible");
    }
}
// When the user clicks on the button, scroll to the top of the document
backbutton.onclick = function() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}